import React from 'react';
import cx from 'classnames';

import { SiteConfigManager } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

const SearchEmptyState = () => {
  const view = SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType');

  const className = cx('empty-search', {
    simplified: view === 'simplified',
  });

  return (
    <EmptyStateView
      className={className}
      description="sportsbook_search_nothing_found"
      title="sportsbook_search_no_results"
    />
  );
};

export default SearchEmptyState;
